import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VideoCameraIcon } from '@heroicons/react/24/outline';

/**
 * Read-only YouTube thumbnail. The URL is owned by YouTube (set by the
 * server), so it is only ever displayed, never edited or sent back.
 * Pass an empty alt when the title is already shown next to it.
 */
VideoThumbnail.propTypes = {
  url: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium'])
};

export default function VideoThumbnail(props) {
  const { url, alt = '', size = 'small' } = props;
  const sizeClass = size === 'small' ? 'w-24 h-[54px]' : 'w-64 h-36';

  if (!url) {
    return (
      <div
        className={classNames(sizeClass, 'flex items-center justify-center rounded bg-cs-gray-100 flex-shrink-0')}
        {...(alt ? { role: 'img', 'aria-label': alt } : { 'aria-hidden': true })}
      >
        <VideoCameraIcon className="h-6 w-6 text-cs-gray-500" aria-hidden="true" />
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      className={classNames(sizeClass, 'object-cover rounded bg-cs-gray-100 flex-shrink-0')}
    />
  );
}
